<template>
  <div v-if="timeslot" class="car-offer-timeslot" data-js="booking-timeslot" :class="{'time-slot--postpone': styleFlag}" @click.prevent="onClick">
    <span v-if="isAppointment" class="car-label">
      {{$t('offer.appointment.appointmentLabel')}}
    </span>
    <span v-else class="car-label">
      {{$t('offer.appointment.label')}}
    </span>

    <div class="car-items">
      <div class="car-item car-item-selected-appointment">
        <span class="car-text">
          {{ timeslot.dateFrom || timeslot.startsAt | moment('LL') }}, {{ timeslot.dateFrom || timeslot.startsAt  | moment('LT') }} -
          {{ getEndTime() | moment('LT') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TimeSlot',
  props: {
    timeslot: {
      type: Object
    },
    styleFlag: {
      type: Boolean,
      default: false
    },
    isAppointment: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getEndTime() {
      return this.timeslot.dateTo || moment(this.timeslot.startsAt).add(this.timeslot.length, 'minute');
    },
    onClick(event) {
      this.$emit('click', event);
    }
  }
}
</script>
